"use client";

import { useEffect } from "react";
import { CheckCircleIcon, XIcon } from "@phosphor-icons/react/ssr";

import Paragraph from "~/componentsDS/Typography/Paragraph";
import { LAYER_CLASS } from "~/constants/layers";
import { cn } from "~/lib/utils";

const LIVE_FEEDBACK_DURATION_MS = 5000;

type Props = {
    message: string;
    onDismiss: () => void;
};

export const LiveFeedbackToast = ({ message, onDismiss }: Props) => {
    useEffect(() => {
        const timer = window.setTimeout(onDismiss, LIVE_FEEDBACK_DURATION_MS);

        return () => window.clearTimeout(timer);
    }, [onDismiss]);

    return (
        <div
            role="status"
            className={cn(
                "pointer-events-none fixed inset-x-6 top-[100px] mx-auto max-w-[628px] font-suisseBP",
                LAYER_CLASS.ABOVE_POPUP
            )}
        >
            <div className="pointer-events-auto motion-safe:animate-in motion-safe:slide-in-from-bottom-full motion-safe:fade-in motion-safe:duration-300 flex items-center gap-2 rounded-2xl bg-success400 p-4 text-gray100 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.05)]">
                <CheckCircleIcon
                    size={24}
                    weight="fill"
                    aria-hidden="true"
                    className="shrink-0"
                />
                <Paragraph size="sm">{message}</Paragraph>
                <button
                    type="button"
                    aria-label="Dismiss feedback"
                    onClick={onDismiss}
                    className="ml-auto shrink-0 rounded-full duration-200 hover:bg-pureWhite/20"
                >
                    <XIcon size={24} aria-hidden="true" />
                </button>
            </div>
        </div>
    );
};
